// Lazy CSRF token acquisition. Первая mutation после mount дёргает
// `GET /api/me/csrf` — сервер ставит HttpOnly cookie `auth_csrf` и
// возвращает token в JSON body; SPA хранит token в module-level кэше
// и шлёт как `X-CSRF-Token` header. Double-submit проверка на сервере.
//
// Кэш живёт всё время сессии страницы. При 403 CSRF mismatch — сбросить
// кэш и повторить один раз (rotation).

let cached: string | null = null;
let inflight: Promise<string> | null = null;

async function fetchToken(): Promise<string> {
  const r = await fetch('/api/me/csrf', {
    credentials: 'same-origin',
    cache: 'no-store',
  });
  if (!r.ok) throw new Error(`csrf ${r.status}`);
  const d = (await r.json()) as { token: string };
  return d.token;
}

export const csrf = {
  async ensure(): Promise<string> {
    if (cached) return cached;
    if (!inflight) {
      inflight = fetchToken()
        .then((t) => {
          cached = t;
          return t;
        })
        .finally(() => {
          inflight = null;
        });
    }
    return inflight;
  },
  invalidate(): void {
    cached = null;
  },
};
